
import BaseCmsBlock from '../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin';

export default BaseCmsBlock.extend({
  name: 'YandexReviewsBlock',

  computed: {
    iframeUrl: function () {
      const yandexReviewsWidgetId = this.$nuxt.context.env?.yandexReviewsWidgetId;
      return `https://yandex.ru/maps-reviews-widget/${yandexReviewsWidgetId}?comments`;
    },
  },
});
